import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'financial.performance.overview',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'revenue.metrics.report.card',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      column: {
                        elements: [
                          {
                            content: {
                              row: {
                                elements: [
                                  {
                                    content: {
                                      widget: {
                                        widget: {
                                          alias: 'ytd.revenue.by.org',
                                        },
                                      },
                                    },
                                    span: 8,
                                  },
                                ],
                              },
                            },
                            height: 400,
                          },
                          {
                            content: {
                              widget: {
                                widget: {
                                  alias: 'yearly.revenue.table',
                                },
                              },
                            },
                            height: 400,
                          },
                        ],
                      },
                    },
                    span: 8,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description: 'Financial Performance overview page',
    name: 'Financial Performance Overview',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
